import { Inject, Injectable, Injector } from '@angular/core';



@Injectable({ providedIn: 'root' })
export class ShipTheory_ReportService {

  constructor(
    private injector: Injector
  ) {
  }

  public ShipTheory: ShipTheory_ReportService = this;

  // injecting lazily in order to avoid circular dependencies
}

